import { Box, Stack, Typography } from '@mui/material';
import { alpha, Theme } from '@mui/material/styles';
import React from 'react';

export type UploadStepInfoCardTone = 'upload' | 'workflow' | 'jobs' | 'manifest';

const getToneColor = (theme: Theme, tone: UploadStepInfoCardTone) => {
  switch (tone) {
    case 'workflow':
      return theme.palette.success.main;
    case 'jobs':
      return theme.palette.warning.main;
    case 'manifest':
      return theme.palette.secondary.main;
    case 'upload':
    default:
      return theme.palette.info.main;
  }
};

interface UploadStepInfoCardProps {
  children?: React.ReactNode;
  description: string;
  icon: React.ReactNode;
  tone?: UploadStepInfoCardTone;
  title: string;
}

const UploadStepInfoCard = ({ children, description, icon, tone = 'upload', title }: UploadStepInfoCardProps) => (
  <Box
    sx={(theme) => {
      const toneColor = getToneColor(theme, tone);

      return {
        border: 1,
        borderColor: alpha(toneColor, 0.42),
        borderLeft: 3,
        borderLeftColor: toneColor,
        borderRadius: 1,
        bgcolor: alpha(toneColor, theme.palette.mode === 'dark' ? 0.08 : 0.04),
        p: 1.25,
      };
    }}
  >
    <Stack spacing={0.75}>
      <Stack direction="row" spacing={1} alignItems="center">
        {icon}
        <Typography variant="subtitle2">{title}</Typography>
      </Stack>
      <Box sx={{ pl: 3.75 }}>
        <Stack spacing={0.75} alignItems="flex-start">
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
          {children}
        </Stack>
      </Box>
    </Stack>
  </Box>
);

export default UploadStepInfoCard;
